import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { AvatarWithLabel, Box, Switch, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField } from 'formik';
import { LabelContainer } from './styled';
export function PublicField(props) {
    const { disabled } = props;
    const [field, , helpers] = useField({
        name: 'isPublic',
        type: 'checkbox',
    });
    const handleOnChange = (checked) => {
        if (disabled) {
            return;
        }
        helpers.setValue(checked);
    };
    const privateLabel = t({
        message: 'Private',
        comment: 'Esigning contacts form - Private field text to toggle private contact',
    });
    const publicLabel = t({
        message: 'Public',
        comment: 'Esigning contacts form - Public field text to toggle public contact',
    });
    const privateDescription = t({
        message: 'The contact is only visible to you',
        comment: 'Esigning contacts form - Private field text to toggle private contact',
    });
    const publicDescription = t({
        message: 'The contact is visible to everyone in your company',
        comment: 'Esigning contacts form - Public field text to toggle public contact',
    });
    return (<LabelContainer>
      <Box display="flex" alignItems="center" gap="md" justifyContent="space-between">
        <AvatarWithLabel size="md" appearance="light" title={field.checked ? publicLabel : privateLabel} subtitle={field.checked ? publicDescription : privateDescription}>
          {field.checked ? <Falcon icon="eye"/> : <Falcon icon="eye-slash"/>}
        </AvatarWithLabel>

        {!disabled && <Switch disabled={disabled} checked={field.checked} onCheckedChange={handleOnChange}/>}
      </Box>

      {!disabled && (<Box bg="semantic.surface.secondary" p="md" borderRadius="md">
          <Typography $fontSize="tiny" $appearance="100">
            <Trans>This can not be changed after it is set.</Trans>
          </Typography>
        </Box>)}
    </LabelContainer>);
}
